import { __decorate, __metadata, __param } from "tslib";
import { Component, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { MemberModelService } from '../../services/member-model.service';
import { AnalyticsService } from '../../shared/utilities/analytics/analytics.service';
import { PensionCalcService } from '../../services/pension-calc.service';
import { AmplitudeEvent } from '../../shared/utilities/analytics/models/amplitude-event-details.model';
var OverviewComponent = /** @class */ (function () {
    function OverviewComponent(router, document, memberModel, pensionCalcService, analytics) {
        this.router = router;
        this.document = document;
        this.memberModel = memberModel;
        this.pensionCalcService = pensionCalcService;
        this.analytics = analytics;
        this.blkNow = false; // when to show the animation
        this.redNow = false; // when to show the animation
        this.thumbDown = false; // when to show the thumbDown rating
        this.thumbUp = false; // when to show the thumbUp rating
        this.how = false;
        this.what = false;
        this.ratio10 = 0;
        this.blkNotes = [];
        this.redNotes = [];
    }
    OverviewComponent.prototype.ngOnInit = function () {
        this.document.body.classList.add('overview');
        this.memberModel.addHistoryAndState(200, 'Overview summary', 'Viewing overview summary');
        this.memberModel.saveHistory();
        this.pensionCalcService.initialize();
        this.animateMoneyStacks();
    };
    OverviewComponent.prototype.ngOnDestroy = function () {
        this.document.body.classList.remove('overview');
    };
    OverviewComponent.prototype.animateMoneyStacks = function () {
        var start = performance.now();
        var times = 0;
        // The blkNote loop is always 10
        this.blkNotes = [];
        this.blkNow = true;
        var _this = this;
        requestAnimationFrame(function animate(time) {
            if ((time - start) > 200) {
                _this.blkNotes.push(times++);
                start = time;
            }
            if (times < 10) {
                requestAnimationFrame(animate);
            }
            else {
                _this.animateRedNotes();
            }
        });
    };
    OverviewComponent.prototype.animateRedNotes = function () {
        var start = performance.now();
        var times = 0;
        var pensionable = this.pensionCalcService.getMonthlyPensionableSalary();
        var retirement = this.pensionCalcService.getRetirementSalary();
        try {
            this.ratio10 = Math.floor((retirement / pensionable) * 10);
            if (this.ratio10 >= 11) {
                this.ratio10 = 11;
            }
            else if (this.ratio10 < 1) {
                this.ratio10 = 1;
            }
        }
        catch (error) {
            this.ratio10 = 6;
        }
        this.redNotes = [];
        this.redNow = true;
        var _this = this;
        requestAnimationFrame(function animate(time) {
            if ((time - start) > 200) {
                _this.redNotes.push(times++);
                start = time;
            }
            if (times < _this.ratio10) {
                requestAnimationFrame(animate);
            }
            else {
                if (_this.ratio10 <= 7) {
                    _this.thumbDown = true; // ratio is not ideal, so thumbs down
                }
                else {
                    _this.thumbUp = true; // ratio is ideal, so thumbs up
                }
            }
        });
    };
    OverviewComponent.prototype.start = function () {
        this.analytics.track('overview-next', { event: AmplitudeEvent.PROCESS_STARTED });
        this.router.navigate(['before']);
    };
    OverviewComponent = __decorate([
        Component({
            selector: 'overview',
            templateUrl: 'app/smart-exits/overview/overview.html'
        }),
        __param(1, Inject(DOCUMENT)),
        __param(2, Inject(MemberModelService)),
        __param(3, Inject(PensionCalcService)),
        __metadata("design:paramtypes", [Router, Object, MemberModelService,
            PensionCalcService,
            AnalyticsService])
    ], OverviewComponent);
    return OverviewComponent;
}());
export { OverviewComponent };
//# sourceMappingURL=data:application/json;base64,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